import Tabs from 'bootstrap/js/dist/tab';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

function clickNav() {
    const menuItems = document.querySelectorAll('.menu-item--children');
    if (window.innerWidth > 991) {
        menuItems.forEach(item => {
            const menuLink = item.querySelector('.menu-link');
            const bigNav = item.querySelector('.big-nav');
            const body = document.querySelector('body');
            
            menuLink.addEventListener("click", function(event) {
                event.stopPropagation();
                const allMenuLinks = document.querySelectorAll('.menu-link');
                const allBigNavs = document.querySelectorAll('.big-nav');
                
                allMenuLinks.forEach(link => {
                    if (link !== menuLink) {
                        link.classList.remove('active');
                        body.classList.remove('overlay');
                    }
                });
                
                allBigNavs.forEach(nav => {
                    if (nav !== bigNav) {
                        nav.classList.remove('active');
                    }
                });

                // Toggle the active class and overlay on body
                const isBigNavActive = bigNav.classList.contains('active');
                menuLink.classList.toggle('active');
                bigNav.classList.toggle('active');

                if (!isBigNavActive && bigNav.classList.contains('active')) {
                    body.classList.add('overlay');
                } else if (isBigNavActive && !bigNav.classList.contains('active')) {
                    body.classList.remove('overlay');
                }
            });

            const back = item.querySelector('.big-nav__back');
            back.addEventListener("click", function() {
                bigNav.classList.remove('active');
            });
        });

        // Handle clicks outside the big-nav
        document.addEventListener("click", function(event) {
            const allBigNavs = document.querySelectorAll('.big-nav.active');
            const body = document.querySelector('body');
            allBigNavs.forEach(nav => {
                if (!nav.contains(event.target)) {
                    nav.classList.remove('active');
                    body.classList.remove('overlay');
                }
            });
        });
    } else {
        menuItems.forEach(item => {
            const menuLink = item.querySelector('.menu-link');
            const bigNav = item.querySelector('.big-nav');
            
            menuLink.addEventListener("click", function(event) {
                event.stopPropagation();
                const allMenuLinks = document.querySelectorAll('.menu-link');
                const allBigNavs = document.querySelectorAll('.big-nav');
                
                allMenuLinks.forEach(link => {
                    if (link !== menuLink) {
                        link.classList.remove('active');
                    }
                });
                
                allBigNavs.forEach(nav => {
                    if (nav !== bigNav) {
                        nav.classList.remove('active');
                    }
                });

                // Toggle the active class and overlay on body
                const isBigNavActive = bigNav.classList.contains('active');
                menuLink.classList.toggle('active');
                bigNav.classList.toggle('active');
            });

            const back = item.querySelector('.big-nav__back');
            back.addEventListener("click", function() {
                bigNav.classList.remove('active');
            });
        });
    }
}


// GSAP ANIMATION FADE
function fadeUpOnScroll() {
    const fadeUpEl = document.querySelectorAll('.fade-up');
    setTimeout(() => {
        fadeUpEl.forEach((item) => {
            gsap.to(item, {
                y: 0,
                autoAlpha: 1,
                duration: 0.8,
                ease: "ease",
                scrollTrigger: {
                    trigger: item,
                    start: "top-=100px bottom-=15%",
                },
            })
        })
    }, 500);
}

function toggleLanguageSwitcher() {
    const languageSwitcher = document.querySelector('.language-switcher');
    if (!languageSwitcher) {
        return;
    }

    languageSwitcher.addEventListener('click', function(event) {
        this.classList.toggle('active');
    });

    // Close the language switcher when clicking outside
    document.addEventListener('click', function(event) {
        if (!languageSwitcher.contains(event.target)) {
            languageSwitcher.classList.remove('active');
        }
    });
}

function closeAnnouncementBar() {
    const navbarPrimaryEl = document.querySelector('.navbar-custom')
    const announcementBar = document.querySelector('.announcement-bar');
    if (announcementBar) {
        
        const closeButton = announcementBar.querySelector('.announcement-bar__close-btn');

        closeButton.addEventListener('click', function() {
            announcementBar.classList.add('is-hidden');
            navbarPrimaryEl.style.top = '0';
            // delete inline margin-top of banner
            const banner = document.querySelector('main > .banner');
            if (banner) {
                banner.style.marginTop = '';
            }
        });
    }
}

function checkNavbarScrolled() {
    const navbarPrimaryEl = document.querySelector('.navbar-custom')

    if (navbarPrimaryEl) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 50) {
                navbarPrimaryEl.classList.add('scrolled')
            } else {
                navbarPrimaryEl.classList.remove('scrolled')
            }
        })
    }
}

function setNavbarPosition() {
    const navbarPrimaryEl = document.querySelector('.navbar-custom');
    const announcementBar = document.querySelector('.announcement-bar');
    const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
    const navbarPrimaryElHeight = navbarPrimaryEl ? navbarPrimaryEl.offsetHeight : 0;

    if (announcementBar) {
        navbarPrimaryEl.style.top = `${announcementBarHeight}px`;

        // increase margin-top of banner
        const banner = document.querySelector('main > .banner');
        if (banner) {
            banner.style.marginTop = `${announcementBarHeight + navbarPrimaryElHeight}px`;
        }
    }
}

export { gsap, ScrollTrigger, clickNav, fadeUpOnScroll };

document.addEventListener('DOMContentLoaded', function() {
    toggleLanguageSwitcher();
    closeAnnouncementBar()
    checkNavbarScrolled()
    setNavbarPosition()
});

// WEB LOADING
window.addEventListener('load', function() {
    const loader = document.querySelector('.preloader-area');
    loader.style.display = 'none';
});

window.addEventListener('shown.bs.tab', () => {
    ScrollTrigger.refresh()
});

window.addEventListener('shown.bs.collapse', () => {
    ScrollTrigger.refresh()
});